// Invite block (§5.2) — the app's growth mechanism, top of the dashboard.
// Uses navigator.share when available, clipboard fallback otherwise (§4).

import { useState } from "react";

export function InviteBlock({ shareSlug }: { shareSlug: string }) {
  const [copied, setCopied] = useState(false);
  const url = `${typeof window !== "undefined" ? window.location.origin : "https://twoshot.xyz"}/with/${shareSlug}`;

  async function share() {
    if (typeof navigator !== "undefined" && navigator.share) {
      try {
        await navigator.share({ title: "Blend film taste on twoshot", url });
        return;
      } catch {
        /* fall through to copy */
      }
    }
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      setCopied(false);
    }
  }

  return (
    <div className="card border-gold-500/30" data-testid="section-invite">
      <h2 className="section-title">Your link</h2>
      <p className="mb-3 text-sm text-ink-400">
        Send this to anyone whose taste you're curious about. When they join, you both get a blend.
      </p>
      <div className="flex flex-col gap-2 sm:flex-row">
        <input
          readOnly
          data-testid="invite-url"
          value={url}
          className="min-w-0 flex-1 rounded-lg border border-border-strong bg-paper-50 px-3 py-2.5 text-sm text-ink-900"
          onFocus={(e) => e.currentTarget.select()}
        />
        <button type="button" data-testid="action-share-invite" className="btn-primary shrink-0" onClick={share}>
          {copied ? "Copied!" : "Copy / Share"}
        </button>
      </div>
    </div>
  );
}
